module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.text))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "multiLanguage": _vm.multiLanguage,
      "selPage": _vm.selPage,
      "page": _vm.page,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "sort": _vm.sort,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }, [_c('div', {
    staticClass: "ibReportSlot",
    attrs: {
      "slot": "handle"
    },
    slot: "handle"
  }, [_c('div', {
    staticClass: "ibReportSelect"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.statusText))]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    on: {
      "change": _vm.searchData
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, _vm._l((_vm.multiLanguage.ibreport.statusList), function(key, val) {
    return _c('el-option', {
      key: val,
      attrs: {
        "label": key,
        "value": val
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "ibReportInput"
  }, [_c('span', [_vm._v(_vm._s(_vm.multiLanguage.ibreport.ibAccountText))]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    model: {
      value: (_vm.ibAccount),
      callback: function($$v) {
        _vm.ibAccount = $$v
      },
      expression: "ibAccount"
    }
  }), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchData
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.multiLanguage.search) + "\n                        ")]), _vm._v("\n                                    \n                    ")], 1)])]) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a10dbfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBReport/ibReport.vue
// module id = 1080
// module chunks = 1